import { PagingParams } from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/grappa/types/grappa.types';

export const ARTICLES_PER_PAGE = 5;
export const MINIMUM_SEARCH_LENGTH = 3;

/** The design calls for max 30 results to be shown */
export const paging: PagingParams = {
  first: 30,
  offset: 0,
};
